module.exports = __webpack_public_path__ + "static/img/logo_xa.bd34d70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_xa.png
// module id = GWqD
// module chunks = 12